import {BI_ENDPOINTS, BI_ORIGINS} from '@wix/wix-events-commons-statics'
import {EventMap} from '../../../../commons/bi/interfaces'
import {Tabs} from '../../../../commons/enums'
import {seeOtherEvents, setTab, shareEventClicked, toggleEventDetails} from '../actions/events'
import {navigateToDetailsPageClicked} from '../actions/navigation'
import {downloadTicketsAction} from '../actions/tickets'
import {MembersPageState} from '../types/state'

export const eventMap: EventMap = {
  [downloadTicketsAction.toString()]: (_state: MembersPageState, action: ReturnType<typeof downloadTicketsAction>) => ({
    evid: 88,
    event_id: action.payload,
    origin: BI_ORIGINS.MEMBERS_AREA,
  }),
  [seeOtherEvents.toString()]: (state: MembersPageState) => ({
    evid: 156,
    action: 'see_other_events',
    tabName: getBiTabName(state.tab),
  }),
  [setTab.toString()]: (_state: MembersPageState, action: ReturnType<typeof setTab>) => ({
    evid: 156,
    action: 'switch_between_tabs',
    tabName: getBiTabName(action.payload),
  }),
  [toggleEventDetails.fulfilled.toString()]: (state: MembersPageState) => ({
    evid: 156,
    action: 'expand_event_details',
    tabName: getBiTabName(state.tab),
  }),
  [shareEventClicked.toString()]: (state: MembersPageState) => ({
    evid: 156,
    action: 'share_event',
    tabName: getBiTabName(state.tab),
  }),
  [navigateToDetailsPageClicked.toString()]: (state: MembersPageState) => ({
    evid: 156,
    action: 'view_event_details',
    tabName: getBiTabName(state.tab),
  }),
  endpoint: BI_ENDPOINTS.EVENTS_UOU,
}

const getBiTabName = (currentTab: Tabs) => (currentTab === Tabs.PAST ? 'past_events' : 'upcoming_events')
